import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore, formatINR } from "@/context/StoreContext";

const ProductCard = ({ product, index = 0 }) => {
  const { toggleWishlist, isWishlisted } = useStore();
  const onSale = product.compareAtPrice && product.compareAtPrice > product.price;
  const wished = isWishlisted(product.handle);

  return (
    <article
      data-testid={`product-card-${product.handle}`}
      className="group animate-fade-up"
      style={{ animationDelay: `${(index % 4) * 80}ms` }}
    >
      <Link to={`/product/${product.handle}`} className="block">
        <div className="relative aspect-[3/4] md:aspect-[4/5] bg-[color:var(--vw-bg-alt)] overflow-hidden hover-zoom">
          <img
            src={product.images[0]}
            alt={product.title}
            loading="lazy"
            className="w-full h-full object-cover"
          />
          {product.images[1] && (
            <img
              src={product.images[1]}
              alt=""
              aria-hidden="true"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700"
            />
          )}
          {onSale && (
            <span className="absolute top-3 left-3 overline bg-[color:var(--vw-bg)] px-2 py-1">Sale</span>
          )}
          <button
            data-testid={`wishlist-${product.handle}`}
            aria-label="Toggle wishlist"
            onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
            className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-[color:var(--vw-bg)]/85 backdrop-blur-sm hover:bg-[color:var(--vw-bg)] transition-colors"
          >
            <Heart
              size={16}
              strokeWidth={1.5}
              className={wished ? "fill-[color:var(--vw-ink)] text-[color:var(--vw-ink)]" : "text-[color:var(--vw-ink)]"}
            />
          </button>
        </div>
      </Link>

      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <Link to={`/product/${product.handle}`} className="font-serif-display text-lg md:text-xl leading-tight hover:opacity-70">
            {product.title}
          </Link>
          <div className="mt-1 flex items-center gap-2 text-sm font-utility">
            <span className="text-[color:var(--vw-ink)] font-medium">{formatINR(product.price)}</span>
            {onSale && (
              <span className="text-[color:var(--vw-ink-soft)] line-through">{formatINR(product.compareAtPrice)}</span>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
